import { Component, Input } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Action, select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { ModalActions } from '@shared/modal/modal.config';

import { ModalCancel, ModalConfirm } from './modal.actions';
import { getModal, ModalState } from './modal.reducer';

export enum ModalButtonType {
  danger,
}

@Component({
  selector: 'mojo-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
})
export class ModalComponent {
  modal$: Observable<ModalState> = this.store.pipe(select(getModal));
  readonly ModalActions = ModalActions;
  @Input()
  confirmAction: Action[] = [];

  @Input()
  disableSave = false;

  constructor(private store: Store<{}>, private dialogRef: MatDialogRef<unknown>) {}

  confirm() {
    if (this.confirmAction && this.confirmAction.length > 0) {
      this.confirmAction.forEach((action) => this.store.dispatch(action));
    } else {
      this.store.dispatch(new ModalConfirm());
    }
    this.close();
  }

  cancel() {
    this.store.dispatch(new ModalCancel());
    this.close();
  }

  close() {
    this.dialogRef.close('Close click');
  }
}
